"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _api = require("@polkadot/api");

var _operators = require("rxjs/operators");

var _options = require("./options");

var _Margin = _interopRequireDefault(require("./Margin"));

var _Synthetic = _interopRequireDefault(require("./Synthetic"));

var _Currencies = _interopRequireDefault(require("./Currencies"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

class LaminarApi {
  constructor(options) {
    this.api = void 0;
    this.chainType = 'laminar';
    this.margin = void 0;
    this.synthetic = void 0;
    this.currencies = void 0;

    this.extrinsicHelper = (extrinsic, signOption, {
      action
    } = {}) => {
      return new Promise((resolve, reject) => {
        const actionStatus = {
          txHash: extrinsic.toHex(),
          action
        };
        extrinsic.signAndSend(signOption).subscribe(result => {
          if (result.status.isInBlock) {
            actionStatus.blockHash = result.status.asInBlock.toHex();
          }

          if (result.status.isFinalized || result.status.isInBlock) {
            actionStatus.data = result;
            actionStatus.account = extrinsic.signer.toString();
            result.events.filter(({
              event: {
                section
              }
            }) => section === 'system').forEach(event => {
              const {
                event: {
                  data,
                  method
                }
              } = event;

              if (method === 'ExtrinsicFailed') {
                const [dispatchError] = data;
                let message = dispatchError.type;

                if (dispatchError.isModule) {
                  try {
                    const mod = dispatchError.asModule;
                    const error = this.api.registry.findMetaError(new Uint8Array([mod.index.toNumber(), mod.error.toNumber()]));
                    message = `${error.section}.${error.name}`;
                  } catch (error) {// swallow
                  }
                }

                actionStatus.message = message;
                actionStatus.status = 'error';
                reject(actionStatus);
              } else if (method === 'ExtrinsicSuccess') {
                actionStatus.status = 'success';
                resolve(actionStatus);
              }
            });
          } else if (result.isError) {
            actionStatus.account = extrinsic.signer.toString();
            actionStatus.status = 'error';
            actionStatus.data = result;
            reject(actionStatus);
          }
        }, error => {
          actionStatus.message = error.message;
          actionStatus.data = error;
          actionStatus.status = 'error';
          actionStatus.account = extrinsic.signer.toString();
          reject(actionStatus);
        });
      });
    };

    this.isReady = async () => {
      await this.api.isReady.pipe((0, _operators.first)()).toPromise();
    };

    const allOptions = (0, _options.options)(_objectSpread(_objectSpread({}, options), {}, {
      types: _objectSpread({}, options.types),
      provider: options.provider
    }));
    this.api = new _api.ApiRx(allOptions);
    this.margin = new _Margin.default(this);
    this.synthetic = new _Synthetic.default(this);
    this.currencies = new _Currencies.default(this);
  }

}

LaminarApi.tokenIds = ['LAMI', 'AUSD', 'FEUR', 'FJPY', 'FBTC', 'FETH', 'FAUD', 'FCAD', 'FCHF', 'FXAU', 'FOIL', 'FGBP'];
var _default = LaminarApi;
exports.default = _default;